module.exports = __webpack_public_path__ + "img/label-share.111505c9.png";